import React, {Component} from 'react';
import compose from '../../utils/compose'
import { AppDataParam } from '../../utils/constUtils'
import withNofeshService  from '../../hoc/withNofeshService.hoc';

class SearchFieldGuests extends Component {

    state = { 
        open:false,
        searchFieldOK : false,
        personsChildren : [],
        searchFieldGuests_placeholder: '',
        num_family_adulds : 0,
        num_children:0,
        num_babies:0
    }

    getSnapshotBeforeUpdate(prevProps, prevState) {
        if (prevProps.shouldClose === false && this.props.shouldClose === true)
        {
            this.setState({open:false}); 
        }
        return null;
    }
    
    componentDidUpdate(prevProps, prevState, snapshot) {

    }
    
    componentDidMount = () => {        

        const { personsChildren }= this.props.personData;

        const { 
            search_param_num_family_adulds,
            search_param_num_family_children,
            search_param_num_family_babies,
            searchFieldGuests_placeholder }= this.props.currentSearchObj;

        this.setState(
            { 
                personsChildren: personsChildren,
                num_family_adulds: search_param_num_family_adulds,
                num_children: search_param_num_family_children,
                searchFieldGuests_placeholder : searchFieldGuests_placeholder
            }); 

        console.log('SearchFieldGuests componentDidMount state: ', this.state);
    }
  
 

    getGuestsText = () =>  { 
        let s = '';
        let num_children = 0;
        let num_babies = 0;
               

        if (this.state.num_family_adulds == 1) {
            s = 'מבוגר 1'
        } else {
            s = 'מבוגרים ' + this.state.num_family_adulds;
        }

        this.state.personsChildren.forEach(function (child) {
            if (child.selected) {
                if (child.child_type ==1) {
                    num_children = num_children + 1;
                }
                if (child.child_type ===2) {
                    num_babies = num_babies +1;
                }
            }
        });

            
        if(num_children > 1) {            
            s = s + ',' +   'ילדים ' + num_children.toString();
        } else if(num_children == 1) {            
            s = s + ',' + 'ילד ' + num_children.toString();
        }
        if(num_babies > 1) {            
            s = s + ',' + 'תינוקות ' + num_babies.toString();
        }else if(num_babies === 1) {            
            s = s + ',' + 'תינוק ' +   num_babies.toString();
        }

 
        if ( s.length > 28) {s = s.substring(0,27) + ' ...';}
       
        
        this.setState({num_children:num_children});
        this.setState({num_babies:num_babies});

        return s;

    }


    setOK = () =>  { 
        let guestsTxt = this.getGuestsText();        
        this.setState({searchFieldGuests_placeholder:guestsTxt});
        this.setState({searchFieldOK:true});        
        this.setState({open:false});   

        const data = {
            num_family_adulds : this.state.num_family_adulds,
            personsChildren : this.state.personsChildren,
            searchFieldGuests_placeholder: guestsTxt,
            search_param_num_family_adulds : this.state.num_family_adulds,
            search_param_num_family_children : this.state.num_children,
            search_param_num_family_babies : this.state.num_babies,
            lastChanceType : 0
        };               
        
        this.props.setCurrentAppData(data, AppDataParam.set_app_data);
    }

    resetClear = () =>  { 

        const { num_family_adulds } = this.props.personData;
        this.setState({searchFieldOK:false});    
        this.setState({searchFieldGuests_placeholder:''});  
        this.setState({num_family_adulds:num_family_adulds}); 
        this.setState(prevState => ({
            personsChildren: prevState.personsChildren.map(
            obj  => {
                let t = {};
                Object.assign(t, obj);
                t.selected = false;
                Object.assign(obj, t); 
                return obj;
            }
          )
        }));
       

        this.props.setCurrentAppData(null, AppDataParam.reset_search_param_guests);
    }

    toggleOpenClose = () =>  {
        const open = !this.state.open;    
        this.setState({open:open});  
        let data = {};
        data.SearchFieldGuestsOpened = open;
        this.props.updateOpenSearchFieldFn(data);
    }  

    toggleEilat = ()  => {        
        const b = this.state.checkedEilat;
        this.setState({ checkedEilat: !b });                
    }


    toggleChild = (o) => {
        let chld = o;
        chld.selected = !o.selected;
        this.setState(prevState => ({
            personsChildren: prevState.personsChildren.map(
            obj => (obj.key === o.key ? Object.assign(obj, chld) : obj)
          )
        }));
    }

    isChildSelected = (o)  => {
        if (o.selected) {
            return true;
        }
        return false;
    }

    isChildBaby = (o)  => {
        if (o.child_type === 2) {
            return true;
        }
        return false;
    }


    addAdult = ()  => {  
        let num = this.state.num_family_adulds;
        num = num +1;
        if (num > 2) { num = 2;}
        this.setState({num_family_adulds:num}); 
    }

    
    subAdult = ()  => {  
        let num = this.state.num_family_adulds;
        num = num - 1;
        if (num < 1) { num = 1;}
        this.setState({num_family_adulds:num}); 
    }


  render() {     
    let is_open = false;
    if (this.props.shouldClose) { is_open = false;   }        
    is_open = this.state.open;

    const personsChildren = this.state.personsChildren.map((o,index) => {
        return (
            <div  key={o.key} onClick={() => this.toggleChild(o)}
                className={                    
                    this.isChildSelected(o)
                    ? 'hp_search_field_dropDown_inner_placeBox  placeBox_selected' 
                    : 'hp_search_field_dropDown_inner_placeBox  placeBox_unselected' }>                                
                <div className="hp_search_field_dropDown_inner_placeBox_check_wrapper">                                    
                    { (this.isChildSelected(o)) ?
                        <img src={"./images/site/components/checked.png"} alt=""/>
                    : 
                        <img src={"./images/site/components/unchecked.png"} alt=""/>
                    }
                </div>
                <div className="hp_search_field_dropDown_inner_DatesMonth_title">{o.name}</div>
                <div className="hp_search_field_dropDown_inner_placeBox_picWrapper">                    
                    { (this.isChildBaby(o)) ?
                        <img className="unselectable" src={"./images/site/components/baby.png"} alt=""/>
                    :
                        (o.sex === 1) ? 
                        <img className="unselectable" src={"./images/site/components/boy.png"} alt=""/> 
                        :   <img className="unselectable" src={"./images/site/components/girl.png"} alt=""/>                    
                    }
                </div>
            </div>
        )
    });

    return (

        <React.Fragment>
            <div className="hp_search_field_container hp_search_field_marginRight15 ">

                {(this.state.searchFieldGuests_placeholder !== '')?
                    <span className="hp_search_field_dropDown_inner_placeBox_title_small">
                    כמה נוסעים</span>  : null}

                    <div className="hp_search_field_titleTest_new pointer" onClick={this.toggleOpenClose}>
                    {(this.state.searchFieldGuests_placeholder == '')?
                        <span> כמה נוסעים </span>
                    : 
                    <span>{ this.state.searchFieldGuests_placeholder}</span>
                    }

                    <span className="open_arrow_new pointer" 
                        onClick={this.toggleOpenClose}></span>
                    </div>

                { (is_open) ?
                    <div className="hp_search_field_dropDown_container2" >
                        <div className="close_arrow pointer" onClick={this.toggleOpenClose}></div>
                        <div className="hp_search_field_dropDown_innerTitle">הרכב האורחים</div>
                        <div className="hp_search_field_dropDown_inner_container2">
                            <div className="hp_search_field_dropDown_inner_guestBox">
                                מבוגרים
                            </div>
                            <div className="hp_search_field_dropDown_inner_guestBox_adultDiv">
                                <div className="circleButton flex pointer" onClick={this.subAdult}>
                                    <div className="minus"></div>
                                </div>
                                <div className="adult_num">                                    
                                    {this.state.num_family_adulds}
                                </div>
                                <div className="circleButton flex pointer" onClick={this.addAdult}>
                                    <div className="minus">
                                        <div className="plus1"></div>
                                    </div>
                                </div>

                            </div>

                            <div className="hp_search_field_dropDown_inner_guestBox_childTitle">
                            הילדים שמצטרפים לחופשה  
                            </div>
                        </div>

                        <div className="hp_search_field_dropDown_inner_containerChild">

                            {personsChildren}
                        </div>

                        <div className="inlineFlex"></div>
                        <div className="hp_search_field_dropDown_inner_button_ok"
                            onClick={this.setOK}>
                            <div className="title">
                                אישור
                            </div>
                        </div>
                        <div className="hp_search_field_dropDown_inner_button_clear"
                            onClick={this.resetClear}>
                            נקה
                        </div>
                    </div>    
                    : null
                }
            </div>
        </React.Fragment>
    )
  }
}



export default compose(
    withNofeshService()
  )(SearchFieldGuests);